import React, { useEffect, useState } from 'react';
import { Button, notification } from 'antd';

const CURRENT_VERSION = process.env.REACT_APP_VERSION;

//console.log('CURRENT_VERSION', CURRENT_VERSION);

export default function UpdateChecker() {
    const [showUpdate, setShowUpdate] = useState(false);

    useEffect(() => {
        const checkVersion = async () => {
            try {
                const res = await fetch('/version.json', {
                    cache: 'no-cache'
                });
                const data = await res.json();
                console.log('data', data);
                console.log('CURRENT_VERSION', CURRENT_VERSION);
                if (data.version && data.version !== CURRENT_VERSION) {
                    setShowUpdate(true);
                }
            } catch (e) {
                console.error('Không thể kiểm tra phiên bản mới');
            }
        };

        // Kiểm tra khi load
        checkVersion();

        // Kiểm tra định kỳ mỗi 5 phút
        //const interval = setInterval(checkVersion, 5 * 60 * 1000);
        const interval = setInterval(checkVersion, 60 * 1000); // 1 phút = 60.000ms
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (showUpdate) {
            notification.open({
                message: 'Có phiên bản mới',
                description: 'Ứng dụng đã được cập nhật. Nhấn "Tải lại" để áp dụng.',
                duration: 0,
                btn: (
                    <Button type="primary" onClick={() => window.location.reload(true)}>
                        Tải lại
                    </Button>
                )
            });
        }
    }, [showUpdate]);

    return null;
}
